import React from 'react';
import { getCommonReverseImagePath } from './ImageBox';
import './FallingCoins.css';

const TOTAL_COINS = 8;

function lerp(min: number, max: number, t: number): number {
  return min + (max - min) * t;
}

function randomRange(min: number, max: number): number {
  return lerp(min, max, Math.random());
}

interface CoinItemConfig {
  id: number;
  left: number; // percentage 0-100 across screen
  size: number; // 75px - 145px diameter
  duration: number; // seconds
  delay: number; // negative seconds for immediate random vertical scatter on load
  startRotation: number; // degrees
  endRotation: number; // degrees
  opacity: number;
  useNewMap: boolean;
}

// Generate the initial scattered coins configuration once
const INITIAL_COINS: CoinItemConfig[] = (() => {
  const items: CoinItemConfig[] = [];

  for (let i = 0; i < TOTAL_COINS; i++) {
    const left = randomRange(3, 93);
    const size = Math.round(randomRange(75, 145));
    const duration = randomRange(22, 32);
    // Negative delay between 0 and full duration scatters coins randomly across the entire viewport on load
    const delay = -randomRange(0, duration);
    const startRotation = randomRange(-60, 60);
    const endRotation = startRotation + (Math.random() < 0.5 ? 1 : -1) * randomRange(180, 540);
    const opacity = randomRange(0.16, 0.24);
    const useNewMap = Math.random() < 0.5;

    items.push({
      id: i,
      left,
      size,
      duration,
      delay,
      startRotation,
      endRotation,
      opacity,
      useNewMap,
    });
  }

  return items;
})();

export const FallingCoins: React.FC = React.memo(() => {
  return (
    <div className="falling-coins-layer" aria-hidden="true">
      {INITIAL_COINS.map((c) => {
        const reverseSrc = getCommonReverseImagePath('2euro', c.useNewMap ? 2008 : 2002);

        return (
          <div
            key={c.id}
            className="falling-coin-wrapper"
            style={{
              left: `${c.left}%`,
              width: `${c.size}px`,
              height: `${c.size}px`,
              animationDuration: `${c.duration}s`,
              animationDelay: `${c.delay}s`,
              opacity: c.opacity,
              '--start-rot': `${c.startRotation}deg`,
              '--end-rot': `${c.endRotation}deg`,
            } as React.CSSProperties}
          >
            <img
              src={reverseSrc}
              alt=""
              className="falling-coin-img"
              draggable={false}
            />
          </div>
        );
      })}
    </div>
  );
});

FallingCoins.displayName = 'FallingCoins';
